import React from 'react';
import BackToHome from './BackToHome';
import './LegalPages.css';

const RefundPolicy = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="site-page-topbar legal-page-topbar">
          <BackToHome />
        </div>

        <div className="legal-content">
          <h1>Refund Policy</h1>
          <p className="last-updated">Last updated: January 25, 2026</p>
          
          <section>
            <h2>1. Refund Policy</h2>
            <p>
              All refund requests are subject to the sole discretion of Cube Solutions LLC. We are under no obligation 
              to provide refunds for any paid subscriptions, regardless of the circumstances.
            </p>
            <p>
              <strong>Our Discretion:</strong> Cube Solutions LLC reserves the right to approve or deny any refund request 
              at its sole discretion. Refund decisions are final and not subject to appeal.
            </p>
            <p>
              To request a refund, please contact our support team at contact@pycrust.io with your account information, 
              subscription details, and reason for the refund request. We will review your request and respond at our 
              discretion.
            </p>
          </section>

          <section>
            <h2>2. Subscription Cancellation</h2>
            <p>
              You may cancel your subscription at any time through the Stripe Customer Portal or by contacting us. 
              Cancellation will take effect at the end of your current billing period. You will retain access to the 
              Service until the end of the billing period for which you have already paid.
            </p>
            <p>
              <strong>No Partial Refunds:</strong> We do not provide partial refunds for unused portions of a billing period. 
              If you cancel mid-cycle, you will retain access until the end of the period you have already paid for.
            </p>
          </section>

          <section>
            <h2>3. Contact Information</h2>
            <p>
              For questions about refunds or billing, please contact us at:
            </p>
            <p>
              Email: contact@pycrust.io<br />
              Company: Cube Solutions LLC
            </p>
            <p>
              We aim to respond to all refund requests within 24 hours during business days.
            </p>
          </section>

          <section className="legal-page-footer-note">
            <p>&copy; 2025 pycrust.io. All rights reserved by Cube Solutions LLC.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
